export default __webpack_public_path__ + "media/images/images/carousel/15-0deff227da10aaaa95db3fa3cff41aa0.jpg";